module.exports = __webpack_public_path__ + "img/9788959523276.2f8a51a4.jpg";